import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchModel, SearchResultModel } from 'src/common';
import { environment } from 'src/environments/environment';
import { CompanyModel } from './company.model';

const localApiUrl = `${environment.apiUrl}/Companies`;

@Injectable()
export class CompaniesService {

    constructor(private http: HttpClient) { }

    search(search: SearchModel): Promise<SearchResultModel<CompanyModel>> {
        return this.http.post<SearchResultModel<CompanyModel>>(`${localApiUrl}/Search`, search).toPromise();
    }

    getAll(): Promise<CompanyModel[]> {
        return this.http.get<CompanyModel[]>(`${localApiUrl}/All`).toPromise();
    }

    getById(id: number): Promise<CompanyModel> {
        return this.http.get<CompanyModel>(`${localApiUrl}/Details/${id}`).toPromise();
    }
}
